import { Stack, Typography } from '@mui/material'
import { FC } from 'react'

const NotFoundContent: FC = () => {
  return (
    <Stack
      sx={{ flex: 1 }}
      alignContent="center"
      justifyContent="center"
      textAlign="center"
      padding={3}
    >
      <Stack gap={2}>
        <Typography variant="subtitle1">
          アップロード済みのCSVはまだありません
        </Typography>
        <Typography variant="body2">
          CSVがアップロードされるとここに処理状況が表示されます
        </Typography>
      </Stack>
    </Stack>
  )
}

export default NotFoundContent
